import { Component, Input, OnInit } from '@angular/core';
import { InsightsService } from '../../../services/insights-service';
import { UserService } from '../../../services/user-service';

@Component({
  selector: 'app-insights-layout',
  templateUrl: './insights-layout.component.html',
  styleUrls: ['./insights-layout.component.scss'],
  standalone: false
})
export class InsightsLayoutComponent implements OnInit {
  @Input() isLoggedIn: boolean = false;
  @Input() isInsightsLandingPage: boolean = false;

  constructor(
    private insightsService: InsightsService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.isInsightsLandingPage = this.insightsService.isInsightsDomain() && window.location.pathname === '/';
  }

  /** True when the insights header (navbar) should be shown. Uses UserService so the header shows on request-access right after login. */
  get showHeader(): boolean {
    return this.isLoggedIn || this.userService.isLoggedIn();
  }
}

